export const feedback = {
  namespaced: true,
  state: {
    message: null,
    timeout: 4000,
    snackbar: false,
    color: ''
  },

  mutations: {
    SET(state, payload) {
      state.message = payload.message
      state.snackbar = true
      state.color = payload.color
    },

    CLEAR(state) {
      state.message = null
      state.snackbar = false
      state.color = ''
    }
  },

  actions: {
    show({commit}, payload) {
      commit('SET', payload)
    },

    close({commit}) {
      commit('CLEAR')
    }
  },

  getters: {
    feedback(state) {
      return state
    }
  },
}  